import { saveCData } from "./storage.js";
import { DC } from "./index.js"; // circular import ok if function only

export function setupRouter() {
  let lastUrl = location.href;

  function handleChange() {
    const url = new URL(location.href);
    const params = Object.fromEntries(url.searchParams.entries());

    if (params.c_src && params.c_mod) {
      saveCData(params.c_src, params.c_mod, params.c_info);
    }

    if (location.href !== lastUrl) {
      lastUrl = location.href;
      DC.pageview(location.href);
    }
  }

  const push = history.pushState;
  history.pushState = function () {
    push.apply(this, arguments);
    handleChange();
  };

  const rep = history.replaceState;
  history.replaceState = function () {
    rep.apply(this, arguments);
    handleChange();
  };

  window.addEventListener("popstate", handleChange);
  window.addEventListener("hashchange", handleChange);

  setTimeout(handleChange, 0);
}
